import type {
  ApiEnvironment,
  ApiUser,
} from 'api/userEnvironment/types/ApiUserEnvironment';
import { getEmbedSearchWidgetIdFromPathname } from 'modules/embedSearchWidget/utils/getEmbedSearchWidgetIdFromPathname';
import { registerMixpanelProperties } from 'utils/analytics/helpers/mixpanel';
import { configureAnalyticsUserData } from 'utils/analytics/setup/configureAnalyticsUserData';
import { configureTrackJs } from 'utils/configureTrackJs';
import { trackReferrals } from 'utils/trackReferral';

type Args = {
  user: ApiUser | null;
  environment: ApiEnvironment;
};

export function configureTracking({ user, environment }: Args) {
  // Tracking
  configureTrackJs(user ? user.id : null);
  configureAnalyticsUserData({ user, environment });

  const embedSearchWidgetId = getEmbedSearchWidgetIdFromPathname(
    window.location.pathname,
  );
  if (embedSearchWidgetId)
    registerMixpanelProperties({ embed_search_widget_id: embedSearchWidgetId });

  trackReferrals();
}
